import { formatDate as kitchenFormatDate } from '@thefarmersfront/kitchen-utensil';

import type { Dayjs } from 'dayjs';

/**
 * 주어진 날짜를 지정된 포맷에 맞게 변환해주는 함수
 *
 * @param {Dayjs | Date | string | null | undefined} date - 변환할 날짜
 * @param {string} format - 사용할 날짜 포맷 문자열
 * @returns {string | null} 포맷된 날짜 문자열 또는 날짜가 유효하지 않은 경우 null
 */
const formatDate = (date: Dayjs | Date | string | null | undefined, format: string): string | null => {
  const result = kitchenFormatDate(date, { format });

  return result ?? null;
};

export default formatDate;
